<template>
  <div class="p-6">
    <div class="d-flex flex-wrap gap-5 align-items-center">
      <div class="d-flex flex-column">
        <h4 class="font-weight-bolder text-capitalize text-white width-name w-100 mb-5">
          Hi, {{ userName }}
        </h4>
        <div class="d-flex">
          <div class="childInfo">
            <div class="avatarIconContainerParent">
              <img
                :src="childSelectedAvatar ? childSelectedAvatar : require(`@/assets/avatar.png`)"
                alt="Avatar icon"
              />
              <div
                class="bg-coin d-flex justify-content-center align-items-center bg-coin-absolute"
              >
                <p
                  class="h1 font-weight-bolder mb-3"
                  :class="coinsStringLength <= 4 ? 'ph1' : 'ph2'"
                >
                  {{ coinsInfo.banked }}
                </p>
              </div>
            </div>
            <section class="childSelector">
              <b-dropdown :text="childSelectedName" lazy>
                <b-dropdown-item
                  v-for="child in childrenData"
                  @click="selectChild(child)"
                  :key="child.id"
                >
                  {{ child.name }}
                </b-dropdown-item>
              </b-dropdown>
            </section>
          </div>
          <div class="d-flex gap-2 justify-content-center align-items-center text-light">
            <div class="d-flex align-items-center gap-2 justify-content-center text-light"></div>
            <span
              class="bg-green-btn rounded-pill px-3 py-2 text-capitalize d-flex align-items-center"
            >
              <span class="material-icons">bolt</span>
              {{ levelInfo.name }}
            </span>
            <span class="m-0">{{ levelInfo.score }} pts</span>
          </div>
        </div>
      </div>
      <motivational-message />
    </div>
  </div>
</template>

<script>
import MotivationalMessage from '../MotivationalMessage.vue';

export default {
  props: {
    userIsAParent: { type: Boolean, default: false },
    userName: { type: String, required: true },
    levelInfo: { type: Object, required: true },
    coinsInfo: { type: Object, required: true },
    childrenData: { type: Array, required: true },
    childSelectedId: { type: String, require: true },
  },
  components: {
    MotivationalMessage,
  },
  computed: {
    childSelectedName() {
      let child = this.childrenData.find((element) => element.id == this.childSelectedId);
      if (child) {
        return child.name;
      }
      return '';
    },
    childSelectedAvatar() {
      let child = this.childrenData.find((element) => element.id == this.childSelectedId);
      if (child) {
        return child.avatar;
      }
      return null;
    },
    coinsStringLength() {
      if (this.coinsInfo.banked) {
        return this.coinsInfo.banked.toString().length;
      }
      return 0;
    },
  },
  methods: {
    selectChild(child) {
      this.$emit('onChildSelectedChange', { childId: child.id });
    },
  },
};
</script>
<style lang="scss">
.p-6 {
  padding: 3rem 3rem 7rem 3rem;

  @media (max-width: 700px) {
    padding: 3rem 1.5rem 7rem 1.5rem;
  }
}
.header-container {
  padding-bottom: 103px !important;
  padding: 0 20px;
  align-items: center;
}
.bg-badge-small {
  height: 25px;
  width: 25px;
}
.width-139 {
  width: 139px;
}

.sentence {
  width: 393px;
  padding-left: 18px;
  margin-top: -46px;
}
.width-name {
  width: 200px;
}

.childInfo {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}

.avatarIconContainerChild {
  background-color: white;
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 100%;
  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 100%;
  }
}

.avatarIconContainerParent {
  background-color: white;
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 100%;
  left: 0;
  z-index: 2;
  & > img {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 100%;
  }
}

.childSelector {
  position: relative;
  padding-left: 5rem;

  & .dropdown-toggle {
    border-radius: 50px;
    background-color: transparent;
    border: none;
  }

  & .dropdown-menu {
    max-height: 50vh;
    overflow-y: auto;
  }

  & .show > .btn-secondary.dropdown-toggle {
    background-color: transparent;
    border-color: transparent;
    border: none;
  }
}

.bg-coin-absolute {
  position: absolute;
  width: 65%;
  top: 65%;
  left: 65%;
}

.notificationButton {
  width: 24px;
  height: 24px;
  padding: 1.2rem;
  display: flex;
}

.levelPoints {
  text-align: center;
}

@media (max-width: 992px) {
  .notificationButton {
    display: none;
  }
}
@media (max-width: 992px) {
  .sentence {
    margin-top: 235px;
  }
}

@media (min-width: 200px) and (max-width: 500px) {
  .header-container {
    border-radius: 1.2rem 1.2rem 0 0 !important;
  }
  .sentence {
    margin-top: 25px;
  }

  .levelPoints {
    text-align: right;
  }
}

@media (min-width: 501px) and (max-width: 992px) {
  .header-container {
    border-radius: 1.2rem 1.2rem 0 0 !important;
  }

  .sentence {
    margin-top: -56px;
  }
}
</style>
